import {useEffect} from 'react';

import useOnVisibilityChange from '@/hooks/useOnVisibilityChange';
import notificationUIService from '@/services/pushNotification/notificationUIService';

const useUpdateBadges = () => {
    useEffect(() => {
        notificationUIService.updateAppBadges();
    }, []);
    useOnVisibilityChange(notificationUIService.updateAppBadges);
};

export default useUpdateBadges;
